<div *ngIf="showBucketsBanner" class="other-buckets-banner" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="24px">
  <img *ngIf="!isZeroResult" class="other-buckets-banner__image" [src]="imageUrl" />

  <div class="other-buckets-banner__text" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="8px">
    <p class="other-buckets-banner__text__title">
      {{ 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.TITLE' | translate }}
    </p>
    <div class="other-buckets-banner__text__link" (click)="redirectToOtherBucket(eOtherBuckets.OfferAndStore)">
      {{ 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.SEARCH' | translate }}
      <span class="other-buckets-banner__text__link__search-term"> "{{ searchQuery }}" </span>
      {{ 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.IN' | translate }}
      <span class="other-buckets-banner__text__link__bucket">
        {{ bucketTitles[eOtherBuckets.OfferAndStore] | translate }}
      </span>
    </div>

    <div class="other-buckets-banner__text__link" (click)="redirectToOtherBucket(eOtherBuckets.DeliveryService)">
      {{ 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.SEARCH' | translate }}
      <span class="other-buckets-banner__text__link__search-term"> "{{ searchQuery }}" </span>
      {{ 'CATALOG.CATALOG_PAGE.OTHER_BUCKETS_BANNER.IN' | translate }}
      <span class="other-buckets-banner__text__link__bucket">
        {{ bucketTitles[eOtherBuckets.DeliveryService] | translate }}
      </span>
    </div>
  </div>
</div>
